<template>
    <zen-one
        :showuserinfo="false"
        title="Penguatkuasaan: Jana Notis"
        :crumbs="crumbs"
    >
        <w-flex :gap="3" column>
            <w-card class="sh2">
                <PengeluaranNotis
                    :loading="loading"
                    :searchParams="searchParams"
                    :julat="julat"
                    :search="semak"
                    :daerahOptions="daerahOptions"
                    :mukimOptions="mukimOptions"
                    :julatOptions="julatOptions"
                    :yearOptions="yearOptions"
                    :jenisHakMilikOptions="jenisHakMilikOptions"
                ></PengeluaranNotis>
            </w-card>
            <z-page
                :append-button="true"
                icon="fal fa-paper-plane"
                :title="'Senarai Hak Milik Yang Bebas Notis'"
            >
                <w-flex column>
                    <div class="align-self-end w-flex align-center">
                        <w-alert
                            v-if="selection.length > 0"
                            info
                            :xs="true"
                            class="ma0"
                        >
                            {{ selection.length }} hakmilik telah dipilih.
                        </w-alert>

                        <w-button
                            @click="pilihSemua('Bebas', true)"
                            class="ml3"
                        >
                            Reset pilihan
                        </w-button>
                        <w-button @click="pilihSemua('Bebas')" class="ml3">
                            Pilih
                            {{
                                tItems1.hak_milik ? tItems1.hak_milik.length : 0
                            }}
                            hakmilik
                        </w-button>
                    </div>
                </w-flex>
                <Table
                    :headers="tHeader"
                    :items="tItems1.hak_milik ?? []"
                    :loading="loading"
                >
                    <template #item-cell.index="{ item, label, header, index }">
                        {{
                            (pagination.currentPage - 1) * pagination.perPage +
                            index
                        }}
                    </template>
                    <template #item-cell.check="{ item, label, header, index }">
                        <input
                            type="checkbox"
                            :value="{ id: item.id }"
                            v-model="selection"
                        />
                    </template>
                    <template #item-cell.alamat="{ item, label, header, index }">
                        <p>{{item.alamat1}}</p>
                        <p>{{item.alamat2}}</p>
                        <p>{{item.alamat3}}</p>
                      </template>
                </Table>
                <TablePagination
                    :lastPage="getLastPage1"
                    :currentPage="tItems1.pagination.currentPage"
                    :perPage="tItems1.pagination.perPage"
                    @onClick="onPaginationChange($event, 'Bebas')"

                />

                <Toolbar
                    :label2="'Notis Pentabiran'"
                    :items="tItems1"
                    :enforceUrl="`${apiBaseUrl}/cukai/janaNotis`"
                    @onDoneEnforce="semak"
                    :checkSelect="selection"
                    :searchParams="searchParams"
                    :printExcel="`${apiBaseUrl}/cukai/excelNotis`"
                    :label3="'Tiada'"
                >
                </Toolbar>
            </z-page>

            <z-page
                :append-button="true"
                icon="fal fa-paper-plane"
                :title="'Senarai Hak Milik Yang Terlibat Notis Pentadbiran'"
            >
                <w-flex column>
                    <div class="align-self-end w-flex align-center">
                        <w-alert
                            v-if="selection2.length > 0"
                            info
                            :xs="true"
                            class="ma0"
                        >
                            {{ selection2.length }} hakmilik telah dipilih.
                        </w-alert>

                        <w-button
                            @click="pilihSemua('Pentadbiran', true)"
                            class="ml3"
                        >
                            Reset pilihan
                        </w-button>
                        <w-button
                            @click="pilihSemua('Pentadbiran')"
                            class="ml3"
                        >
                            Pilih
                            {{
                                tItems2.hak_milik ? tItems2.hak_milik.length : 0
                            }}
                            hakmilik
                        </w-button>
                    </div>
                </w-flex>
                <Table
                    :headers="tHeader"
                    :items="tItems2.hak_milik ?? []"
                    :loading="loading"
                >
                    <template #item-cell.index="{ item, label, header, index }">
                        {{
                            (pagination.currentPage - 1) * pagination.perPage +
                            index
                        }}
                    </template>
                    <template #item-cell.notis="{ item, label, header, index }">
                        {{ `${item.notis} (${item.bilangan})` }}
                    </template>
                    <template #item-cell.alamat="{ item, label, header, index }">
                        <p>{{item.alamat1}}</p>
                        <p>{{item.alamat2}}</p>
                        <p>{{item.alamat3}}</p>
                      </template>
                    <template
                        #item-cell.butiran="{ item, label, header, index }"
                    >
                        <w-button
                            @click="
                                dialogs.showButiranNotis = true;
                                notisToSee = item;
                            "
                            text
                        >
                            <w-icon> fal fa-list </w-icon>
                        </w-button>
                    </template>
                    <template #item-cell.check="{ item, label, header, index }">
                        <input
                            type="checkbox"
                            :value="{ id: item.id, notis_id: item.notis_id }"
                            v-model="selection2"
                        />
                    </template>
                </Table>
                <TablePagination
                    :lastPage="getLastPage2"
                    :currentPage="tItems2.pagination.currentPage"
                    :perPage="tItems2.pagination.perPage"
                    @onClick="onPaginationChange($event, 'Pentadbiran')"
                />
                <Toolbar
                    :label="'Notis Pentadbiran'"
                    :label2="'Notis 2A'"
                    :label4="'Notis 6A'"
                    :items="tItems2"
                    :printExcel="`${apiBaseUrl}/cukai/excelNotis`"
                    :searchParams="searchParams"
                    :enforceUrl="`${apiBaseUrl}/cukai/jana2A`"
                    :enforceUrl2="`${apiBaseUrl}/cukai/jana6A`"
                    :reenforceUrl="`${apiBaseUrl}/cukai/tambahPentadbiran`"
                    :printUrl="`${this.apiBaseUrl}/cukai/pdfNotisPentadbiran`"
                    :checkSelect="selection2"
                    @onDoneEnforce="semak"
                />
            </z-page>

        </w-flex>
        <ButiranNotisDialog
            :title="`Butiran Notis ${notisToSee.notis} ${notisToSee.no_hm}`"
            :notis="notisToSee"
            :show="dialogs.showButiranNotis" 
            :searchParams="searchParams"
            @close="dialogs.showButiranNotis = false"
        ></ButiranNotisDialog>
    </zen-one>
</template>
<script>
import { ref, defineComponent, onMounted, watch, computed } from "vue";
import WaveUI from "wave-ui";
import _ from "lodash";
import PengeluaranNotis from "./PengeluaranNotis";
import Table from "../../Component/Table";
import TablePagination from "../../Component/TablePagination";
import Toolbar from "./Toolbar";
import ButiranNotisDialog from "./ButiranNotisDialog";
import { usePage } from '@inertiajs/inertia-vue3';

export default defineComponent({
    components: {
        PengeluaranNotis,
        Table,
        TablePagination,
        Toolbar,
        ButiranNotisDialog,
    },
    setup() {
        const waveui = new WaveUI(app, {});

        const loading = ref(false);
        const pagination = ref({
            perPage: 10,
            currentPage: 1,
            lastPage: 1,
        });
        const total = ref(0);

        const apiBaseUrl = process.env.MIX_API_BASE_URL;
        const selection = ref([]);
        const selection2 = ref([]);

        const tHeader = ref([
            { label: "#", key: "index" },
            { label: "No. Hakilik | Kegunaan/Syarat Tanah", key: "no_hm" },
            { label: "Nama", key: "nama" },
            { label: "Alamat", key: "alamat" },
            { label: "Tunggakan Dari", key: "tunggakan_dari" },
            { label: "Tunggakan Hingga", key: "tunggakan_hingga" },
            { label: "Cukai Tanah/Petak (RM)", key: "cukai", align: "right" },
            {
                label: "Tunggakan Cukai Tanah/Petak (RM)",
                key: "tunggakan",
                align: "right",
            },
            { label: "Notis (Bilangan)", key: "notis" },
            { label: "Butiran", key: "butiran" },
            { label: "", key: "check" },
        ]);

        const tItems1 = ref({
            pagination,
        });
        const tItems2 = ref({
            pagination,
        });

        const jabatan = usePage().props.value.auth.user.jabatan_id;
        const julatOptions = ref([
            { value: ">=", label: ">=" },
            { value: ">", label: ">" },
            { value: "=", label: "=" },
            { value: "<=", label: "<=" },
            { value: "<", label: "<" },
        ]);

        const yearOptions = ref([
            { value: "2014", label: "2014" },
            { value: "2015", label: "2015" },
            { value: "2016", label: "2016" },
            { value: "2017", label: "2017" },
            { value: "2018", label: "2018" },
            { value: "2019", label: "2019" },
            { value: "2020", label: "2020" },
            { value: "2021", label: "2021" },
            { value: "2022", label: "2022" },
        ]);

        const daerahOptions = ref([]);
        const mukimOptions = ref([]);
        const jenisHakMilikOptions = ref([]);

        const crumbs = ref([
            { label: "iHasil", route: "/" },
            { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
            { label: "Penguatkuasaan", route: "/cukai-tanah/penguatkuasaan" },
        ]);

        const julat = ref({
            jenis: null,
            amaun: null,
        });
        watch(julat.value, (ov, nv) => {
            searchParams.value.julat_tunggakan = nv.jenis + nv.amaun;
        });

        const searchParams = ref({
            kod_daerah: "01",
            kod_mukim: "01",
            julat_tunggakan: null,
            tunggakan_dari: null,
            tunggakan_hingga: null,
            jenis_hm: null,
            notis: null,
            no_hm: null,
            kegunaan_tanah: null,
        });

        const dialogs = ref({
            showButiranNotis: false,
        });
        const notisToSee = ref({});

        const getLastPage1 = computed(() => {
            return tItems1.value.total && tItems1.value.total > 0
                ? Math.ceil(
                      tItems1.value.total / tItems1.value.pagination.perPage
                  )
                : 1;
        });

        const getLastPage2 = computed(() => {
            return tItems2.value.total && tItems2.value.total > 0
                ? Math.ceil(
                      tItems2.value.total / tItems2.value.pagination.perPage
                  )
                : 1;
        });


        function onPaginationChange(e, items) {
            switch (items) {
                case "Bebas":
                    tItems1.value.pagination.currentPage = e.value.currentPage;
                    tItems1.value.pagination.perPage = e.value.perPage;
                    bebas();
                    break;
                case "Pentadbiran":
                    tItems2.value.pagination.currentPage = e.value.currentPage;
                    tItems2.value.pagination.perPage = e.value.perPage;
                    pentadbiran();
                    break;
            }
        }
        function getOffsetLimit(p) {
            const offset = (p.currentPage - 1) * p.perPage;
            const limit = p.perPage;

            return { offset, limit };
        }

        function bebas() {
            const { offset, limit } = getOffsetLimit(tItems1.value.pagination);
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: `${apiBaseUrl}/cukai/penguatkuasaan`,
                    responseType: "json",
                    params: {
                        ...searchParams.value,
                        notis: "Tiada",
                        offset,
                        limit,
                    },
                })
                    .then((e) => {
                        tItems1.value = { ...e.data, pagination };
                        resolve(e);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }
        function pentadbiran() {
            const { offset, limit } = getOffsetLimit(tItems1.value.pagination);
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: `${apiBaseUrl}/cukai/penguatkuasaan`,
                    responseType: "json",
                    params: { ...searchParams.value, notis: "Pentadbiran", offset, limit },
                })
                    .then((e) => {
                        tItems2.value = { ...e.data, pagination };
                        resolve(e);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }


        function semak() {
            loading.value = true;
            selection.value = [];
            selection2.value = [];
            tItems1.value.pagination.currentPage = 1
            tItems1.value.pagination.lastPage = 1
            tItems1.value.pagination.perPage = 10
            tItems2.value.pagination.currentPage = 1
            tItems2.value.pagination.lastPage = 1
            tItems2.value.pagination.perPage = 10


            Promise.all([bebas(), pentadbiran()])
                // Promise.all([bebas()])
                .then((e) => {
                    waveui.notify({
                        success: true,
                        message: `Semakan selesai`,
                        timeout: 3000,
                    });
                })
                .catch((err) => {
                    waveui.notify({
                        error: true,
                        message: `Ralat`,
                        timeout: 3000,
                    });
                    console.log(err);
                })
                .finally(() => {
                    loading.value = false;
                });
        }

        onMounted(() => {
            async function fetchMukim() {
                await axios({
                    method: "get",
                    url: `${apiBaseUrl}/daerah`,
                    responseType: "json",
                }).then((e) => {
                    searchParams.value.kod_daerah = e.data[0].kod;
                    daerahOptions.value = e.data.map((el) => {
                        return {
                            value: el.kod,
                            label: `${el.kod} - ${el.keterangan}`,
                        };
                    });
                });

                await axios({
                    method: "get",
                    url: `${apiBaseUrl}/jabatanToDaerah?jabatan=${jabatan}`,
                    responseType:'json',
                }).then((e)=>{
                    console.log(e);
                    searchParams.value.kod_daerah=e.data[0].kod_daerah;
                });


                await axios({
                    method: "get",
                    url: `${apiBaseUrl}/daerah/${searchParams.value.kod_daerah}/mukim`,
                    responseType: "json",
                }).then((e) => {
                    mukimOptions.value = e.data.map((el) => {
                        return {
                            value: el.kod,
                            label: `${el.kod} - ${el.keterangan}`,
                        };
                    });
                });
            }

            async function fetchJenisHakMilik() {
                await axios({
                    method: "get",
                    url: `${apiBaseUrl}/jenis-hak-milik`,
                    responseType: "json",
                }).then((e) => {
                    jenisHakMilikOptions.value = e.data.map((el) => {
                        return {
                            value: el.kod,
                            label: `${el.kod} - ${el.keterangan}`,
                        };
                    });
                });
            }
            fetchMukim();
            fetchJenisHakMilik();
        });

        function pilihSemua(e, reset) {
            switch (e) {
                case "Bebas":
                    if (reset) {
                        selection.value = [];
                        return;
                    }
                    const temp = selection.value.concat(
                        tItems1.value.hak_milik.map((e) => {
                            return { id: e.id };
                        })
                    );
                    selection.value = _.uniqBy(temp, "id");
                    break;
                case "Pentadbiran":
                    if (reset) {
                        selection2.value = [];
                        return;
                    }
                    const temp2 = selection2.value.concat(
                        tItems2.value.hak_milik.map((e) => {
                            return { id: e.id, notis_id: e.notis_id };
                        })
                    );
                    selection2.value = _.uniqBy(temp2, "id");
                    break;
            }
        }

        const semuaBebas = ref({});
        return {
            apiBaseUrl,
            loading,
            total,
            pagination,
            onPaginationChange,
            getLastPage1,
            getLastPage2,
            crumbs,
            tHeader,
            tItems1,
            tItems2,
            jabatan,
            yearOptions,
            julatOptions,
            daerahOptions,
            mukimOptions,
            jenisHakMilikOptions,
            searchParams,
            julat,
            semak,
            // refresh,
            selection,
            selection2,
            dialogs,
            notisToSee,
            pilihSemua,
            semuaBebas,
            // duaA,
            // enamA,
            // lapanA
        };
    },
});
</script>
<style></style>
